import script from "./TreeContact.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeContact.vue?vue&type=script&setup=true&lang=js"

import "./TreeContact.vue?vue&type=style&index=0&id=adc7639a&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adc7639a"]])

export default __exports__